var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.665039H16C16.3541 0.665039 16.694 0.805303 16.9443 1.05566C17.1947 1.30603 17.335 1.64594 17.335 2V12C17.335 12.3541 17.1947 12.694 16.9443 12.9443C16.694 13.1947 16.3541 13.335 16 13.335H4C3.82363 13.335 3.65401 13.4046 3.5293 13.5293L0.665039 16.3936V2C0.665039 1.64594 0.805303 1.30602 1.05566 1.05566C1.30602 0.805303 1.64594 0.665039 2 0.665039Z",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4H13",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H10",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutlined);
export default __webpack_public_path__ + "static/media/chat_outlined.e2674e574b8bb2b92731b9ff01287343.svg";
export { ForwardRef as ReactComponent };